// src/components/ads-admin/Tip.jsx
import React from "react";

export default function Tip({ children }) {
  return (
    <div
      style={{
        marginTop: 10,
        padding: 12,
        borderRadius: 14,
        border: "1px solid rgba(15,23,42,0.10)",
        background: "#f8fafc",
        color: "#0f172a",
        fontSize: 12,
        lineHeight: 1.5,
        fontWeight: 650,
      }}
    >
      {children}
    </div>
  );
}